import React from 'react';

// Reusable HUD icons (stroke-only, single color). Simple/abstract — matches the
// tactical-HUD vocabulary from the design handoff.
const Icon = ({ d, size = 16 }) => (
  <svg
    className="icn"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {d}
  </svg>
);

export const I = {
  Dashboard: <Icon d={<><rect x="3" y="3" width="7" height="9" /><rect x="14" y="3" width="7" height="5" /><rect x="14" y="12" width="7" height="9" /><rect x="3" y="16" width="7" height="5" /></>} />,
  Wallet:    <Icon d={<><path d="M3 7h15a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" /><path d="M3 7l3-3h12" /><circle cx="16" cy="13" r="1.2" /></>} />,
  Struct:    <Icon d={<><path d="M4 21V8l8-5 8 5v13" /><path d="M9 21v-7h6v7" /><path d="M4 12h16" /></>} />,
  Assets:    <Icon d={<><path d="M3 7l9-4 9 4-9 4-9-4z" /><path d="M3 12l9 4 9-4" /><path d="M3 17l9 4 9-4" /></>} />,
  Members:   <Icon d={<><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c.5-3.5 3-5.5 6.5-5.5s6 2 6.5 5.5" /><circle cx="17" cy="9" r="2.5" /><path d="M15 20c.3-2.5 1.7-4 3-4.2" /></>} />,
  Event:     <Icon d={<><rect x="3" y="5" width="18" height="16" rx="1" /><path d="M3 10h18M8 3v4M16 3v4" /><path d="M8 14h3M8 17h6" /></>} />,
  Logs:      <Icon d={<><path d="M5 3h10l4 4v14H5z" /><path d="M8 11h8M8 15h8M8 7h5" /></>} />,
  Stats:     <Icon d={<><path d="M3 20h18" /><rect x="5" y="13" width="3" height="7" /><rect x="11" y="9" width="3" height="11" /><rect x="17" y="5" width="3" height="15" /></>} />,
  Timeline:  <Icon d={<><path d="M3 12h18" /><circle cx="7" cy="12" r="2" /><circle cx="17" cy="12" r="2" /><path d="M7 12v-4M17 12v4" /></>} />,
  Sync:      <Icon d={<><path d="M21 12a9 9 0 0 1-15 6.7L3 16" /><path d="M3 12a9 9 0 0 1 15-6.7L21 8" /><path d="M21 3v5h-5M3 21v-5h5" /></>} />,
  Logout:    <Icon d={<><path d="M14 5V3H4v18h10v-2" /><path d="M20 12H10" /><path d="M16 8l4 4-4 4" /></>} />,
  Plus:      <Icon d={<><path d="M12 5v14M5 12h14" /></>} />,
  Search:    <Icon d={<><circle cx="11" cy="11" r="6" /><path d="m20 20-4.3-4.3" /></>} />,
  Bell:      <Icon d={<><path d="M6 8a6 6 0 0 1 12 0v5l2 3H4l2-3V8z" /><path d="M10 19a2 2 0 0 0 4 0" /></>} />,
  Lock:      <Icon d={<><rect x="4" y="11" width="16" height="10" rx="1" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>} />,
};

export { Icon };
